/* @flow weak */
// typecheck: ignore file
import React from 'react';

import EventTracking, { getEventScreenName, getEventElementName, getEventContextName, getEventProperties } from 'lib/EventTracking';
import createChainedFunction from 'utils/createChainedFunction';


// Dangerous because this should only be used if the component has the correct context types.
export const dangerouslyTrackTapFromComponentInstance = (component: React.Component<*, *, *>) => {
  const elementName = getEventElementName(component.props);
  const screenName = getEventScreenName(component.props, component.context.router);
  if (elementName && screenName) {
    EventTracking.tap(
      screenName,
      elementName,
      getEventContextName(component.props, component.context),
      getEventProperties(component.props.eventProperties, component.context)
    );
  }
};

type Props = {
  eventElementName?: ?string,
  eventScreenName?: ?string,
  eventProperties?: ?Object,
  children?: *,
}

class ClickEventTrigger extends React.Component {
  props: Props;

  static contextTypes = {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
    eventContextName: React.PropTypes.string,
    router: React.PropTypes.object,
  }

  render() {
    const child = React.Children.only(this.props.children);
    return React.cloneElement(child, { ...child.props,
      onClick: createChainedFunction(() => dangerouslyTrackTapFromComponentInstance(this), child.props.onClick),
    });
  }
}

export default ClickEventTrigger;



// WEBPACK FOOTER //
// ./src/components/ClickEventTrigger.jsx